//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { imagePlaceholderProduct } from '~/common';
import { ref } from "@nuxtjs/composition-api";
import { useVSFContext } from "@vue-storefront/core";
export default {
  name: "MoominCharactersList",
  data() {
    return {
      imagePlaceholderProduct
    };
  },
  props: {
    characterList: {
      type: Array,
      default: () => [],
      validator: (characterList) => {
        if(!characterList.length) return true;

        const keysNeeded = ['characterName', 'image'];

        return characterList.every(char => {
          return keysNeeded.every(key => {
            return typeof char[key] != 'undefined';
          })
        })
      }
    },
    showTooltip: {
      type: Boolean,
      default: false,
    },
    hideActiveState: {
      type: Boolean,
      default: false
    },
    linkEnabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ["characterChanged"],
  setup(props, {emit}){
    const {localePath} = useVSFContext();

    const generateLink = (character) => {
      const link = character.link;

      return link ? localePath(link) : ''
    };

    const selectedCharacterIndex = ref(0);
    const selectCharacter = (index) => {
      selectedCharacterIndex.value = index;
      emit("characterChanged", selectedCharacterIndex.value);
    }

    const linkClicked = () => {
      emit('linkClicked');
    }

    const handleClick = (index) => {
      if(props.linkEnabled) {
        linkClicked();
      } else {
        selectCharacter(index);
      }
    }

    return {
      generateLink,
      linkClicked,
      selectCharacter,
      handleClick,
      selectedCharacterIndex
    }
  }
};
